import Vue from "vue";

export default function permissions({ to, next }) {
	let required = to.meta.permissions;

	if (required && required.length) {
		required.forEach(function(permission) {
			if (!Vue.$can(permission)) {
				return next({
					path: "/auth/unauthorized",
					query: { permission: permission }
				});
			}
		});
	}

	return next();
}
